import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import MyContext from "MyContext";
import { message } from "antd";

const NewDegree = () => {
  const [name, setName] = useState("");
  const [photo, setPhoto] = useState(null);
  const [errors, setErrors] = useState({});
  const { endPointUrl, Token } = useContext(MyContext);
  const TOKEN = Token;

  const validate = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Name is required";
    if (!photo) {
      newErrors.photo = "Photo is required";
    } else if (!["image/jpeg", "image/png", "image/jpg"].includes(photo.type)) {
      newErrors.photo = "Only JPG or PNG files are allowed";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const formData = new FormData();
    formData.append("Name", name);
    formData.append("Token", TOKEN);
    formData.append("photo", photo);

    try {
      const response = await axios.post(`${endPointUrl}/Admin/addDegree`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
     message.success("✅ Degree added successfully");
      setName("");
      setPhoto(null);
      setErrors({});
      document.getElementById("photo").value = "";
    } catch (error) {
      console.error("Error adding degree:", error);
       message.error("❌ Error occurred while submitting");
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="mb-0">Add New Degree</h4>
            <Link to="/admin/ListDegree" className="btn btn-outline-primary">
             Show All Degree
            </Link>
          </div>

          <form onSubmit={handleSubmit} encType="multipart/form-data" className="border p-4 rounded shadow-sm bg-white">
            <div className="mb-3">
              <label htmlFor="name" className="form-label">Degree Name</label>
              <input
                type="text"
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              {errors.name && <div className="invalid-feedback">{errors.name}</div>}
            </div>

            <div className="mb-3">
              <label htmlFor="photo" className="form-label">Photo</label>
              <input
                type="file"
                className={`form-control ${errors.photo ? "is-invalid" : ""}`}
                id="photo"
                accept="image/*"
                onChange={(e) => setPhoto(e.target.files[0])}
              />
              {errors.photo && <div className="invalid-feedback">{errors.photo}</div>}
            </div>

            <div className="d-grid">
              <button type="submit" className="btn btn-success">Save Degree</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewDegree;
